import { render } from "./CopyPromoCodeToStore.vue?vue&type=template&id=0d2c6c97"
import script from "./CopyPromoCodeToStore.vue?vue&type=script&lang=js"
export * from "./CopyPromoCodeToStore.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__